import _ from 'lodash';
import update from 'immutability-helper';

const initialState = {
  mpaa: false,
  fact: false,
  iso27001: false,
};

const UPDATE_CERTIFICATIONS = 'certifications/UPDATE_CERTIFICATIONS';

export function receiveCertificationDetails(account) {
  const certifications = _.pick(account, 'certifications');
  if (certifications && certifications.certifications) {
    return (dispatch) =>
      dispatch(updateCertifications(certifications.certifications));
  } else {
    return (dispatch) => dispatch(updateCertifications(initialState));
  }
}

export function updateCertifications(payload) {
  return { type: UPDATE_CERTIFICATIONS, payload };
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case UPDATE_CERTIFICATIONS:
      return update(state, { $set: payload });

    default:
      return state;
  }
}
